"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseShippingToToJSON = exports.PurchaseShippingToFromJSONTyped = exports.PurchaseShippingToFromJSON = exports.instanceOfPurchaseShippingTo = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the PurchaseShippingTo interface.
 */
function instanceOfPurchaseShippingTo(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPurchaseShippingTo = instanceOfPurchaseShippingTo;
function PurchaseShippingToFromJSON(json) {
    return PurchaseShippingToFromJSONTyped(json, false);
}
exports.PurchaseShippingToFromJSON = PurchaseShippingToFromJSON;
function PurchaseShippingToFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !(0, runtime_1.exists)(json, 'first_name') ? undefined : json['first_name'],
        'lastName': !(0, runtime_1.exists)(json, 'last_name') ? undefined : json['last_name'],
        'postalCode': !(0, runtime_1.exists)(json, 'postal_code') ? undefined : json['postal_code'],
        'address1': !(0, runtime_1.exists)(json, 'address_1') ? undefined : json['address_1'],
        'address2': !(0, runtime_1.exists)(json, 'address_2') ? undefined : json['address_2'],
        'state': !(0, runtime_1.exists)(json, 'state') ? undefined : json['state'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
    };
}
exports.PurchaseShippingToFromJSONTyped = PurchaseShippingToFromJSONTyped;
function PurchaseShippingToToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'first_name': value.firstName,
        'last_name': value.lastName,
        'postal_code': value.postalCode,
        'address_1': value.address1,
        'address_2': value.address2,
        'state': value.state,
        'city': value.city,
    };
}
exports.PurchaseShippingToToJSON = PurchaseShippingToToJSON;
